<section id="NewInvestments">
    <div class="row">
        <div class="title-section">
            <h3>صندوق های سرمایه گذاری آبان</h3>
            <h6><a target="_blank" [routerLink]="['/training/mutual-funds']">صندوق
                    سرمایه گذاری مشترک چیست؟</a></h6>
            <h4>شرکت سبدگردان آبان بیش از ۳۳۰۰ میلیارد تومان سرمایه متعلق به بیش از ۲۰۰۰۰۰ سرمایه گذار را مدیریت می‌کند.
            </h4>
        </div>
        <div class="body-section">
            <div class="column medium-6">
                <div class="inner">
                    <div class="text-container">
                        <h6>صندوق کوثر یکم</h6>
                        <p>این صندوق برای سرمایه گذارانی که هدف آنها دریافت عایدی ماهیانه با نرخ مشخص می باشد طراحی شده
                            است.</p>
                        <a target="_blank" [routerLink]="['/services/kousar-fund']">بیشتر
                            بدانم</a>
                        <a class="right" target="_blank" [routerLink]="['/services/kousar-fund']"></a>
                    </div>
                </div>
            </div>
            <div class="column medium-6">
                <div class="inner">
                    <div class="text-container">
                        <h6>صندوق پارس</h6>
                        <p>اگر به دنبال سرمایه گذاری با ریسک متوسط می باشید، در این صندوق سرمایه گذاری کنید.</p>
                        <a target="_blank" [routerLink]="['/services/pars-fund']">بیشتر
                            بدانم</a>
                        <a class="right" target="_blank" [routerLink]="['/services/pars-fund']"></a>
                    </div>
                </div>
            </div>
            <div class="column medium-6">
                <div class="inner">
                    <div class="text-container">
                        <h6>صندوق یکم آبان</h6>
                        <p>عمده منابع این صندوق در سهام شرکت ها سرمایه گذاری می شود و برای سرمایه گذاری با ریسک بالا
                            مناسب است.</p>
                        <a target="_blank" [routerLink]="['/services/yekom-fund']">بیشتر
                            بدانم</a>
                        <a class="right" target="_blank" [routerLink]="['/services/yekom-fund']"></a>
                    </div>
                </div>
            </div>
            <div class="column medium-6">
                <div class="inner">
                    <div class="text-container">
                        <h6>صندوق ندای امید</h6>
                        <p>منافع حاصل از سرمایه گذاری منابع این صندوق صرف حمایت از بیماران سرطانی آذربایجان غربی می
                            گردد.</p>
                        <a target="_blank" [routerLink]="['/services/omid-fund']">بیشتر
                            بدانم</a>
                        <a class="right" target="_blank" [routerLink]="['/services/pars-fund']"></a>
                    </div>
                </div>
            </div>
            <div class="column medium-6">
                <div class="inner">
                    <div class="text-container">
                        <h6>صندوق رشد پایدار</h6>
                        <p>صندوقی با ریسک پایین و قابل معامله در بورس است و برای سرمایه گذارانی که هدف آنها دریافت عایدی ماهانه با نرخ مشخص می باشد طراحی شده است.</p>
                        <a target="_blank" [routerLink]="['/services/sustainable-growth-fund']">بیشتر
                            بدانم</a>
                        <a class="right" target="_blank" [routerLink]="['/services/sustainable-growth-fund']"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>